import { Check, Plus, Trash2, X } from "lucide-react";
import { useAuth, useMessage } from "../../global-components/src";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { Story } from "../../types";
import { useRef, useState } from "react";
import ReactCrop, { centerCrop, convertToPixelCrop, makeAspectCrop, PercentCrop } from "react-image-crop";
import setCanvasPreview from "../../setCanvasPreview";
import { errorMessage } from "../../global-components/src/utils/text";
import axios from "axios";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import Spinner from "../../global-components/src/components/spinner/spiner";

const PlaceholderStory = ({ loading = false } : { loading?: boolean }) => {
  return (
    <>
      {loading ? (
        <div className="story-item" >
          <div className="story-avatar placeholder" style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "#fff", borderRadius: "50%" }}>
          </div>
          <span className="placeholder" style={{ height: 10, width: 30 }}></span>
        </div>
      ): null}
    </>
  );
};

export default PlaceholderStory;
